import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, Button, Container, Typography } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HomeIcon from '@mui/icons-material/Home';

const EcCartCompletePage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const orderId = location.state?.orderId;

  useEffect(() => {
    if (!orderId) {
      navigate('/');
    }
  }, [orderId, navigate]);

  return (
    <Container maxWidth="sm" sx={{ textAlign: 'center', mt: 8, mb: 8 }}>
      <Box display="flex" flexDirection="column" alignItems="center">
        <CheckCircleOutlineIcon color="success" sx={{ fontSize: 60 }} />
        <Typography variant="h4" component="h1" gutterBottom sx={{ mt: 2 }}>
          注文が完了しました
        </Typography>

        <Typography variant="body1" sx={{ mt: 2 }}>
          ご注文をいただき、誠にありがとうございます。
        </Typography>
        <Typography variant="body1" sx={{ mb: 4 }}>
          発送完了まで今しばらくお待ちください。
        </Typography>

        <Box display="flex" gap={2} flexWrap="wrap" justifyContent="center" mb={4}>
          <Button
            variant="outlined"
            onClick={() => navigate(`/orders/${orderId}`)}
          >
            注文を確認する
          </Button>
          <Button
            variant="contained"
            color="primary"
            endIcon={<HomeIcon />}
            onClick={() => navigate('/')}
          >
            トップページへ戻る
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default EcCartCompletePage;
